import { SetStateAction, useState, Dispatch } from 'react'

import Tooltip from '~/components/Tooltip'

import QuestionCirclePurpleIcon from './Icons/svgs/QuestionCirclePurpleIcon'
import SVGIcon from './Icons/svgs/SVGIcon'

import { Toggle } from '.'

export function ToggleCustomizedView({
  isCustomizedView,
  setIsCustomizedView,
  title,
  tooltipText,
}: {
  isCustomizedView: boolean
  setIsCustomizedView: Dispatch<SetStateAction<boolean>>
  title: string
  tooltipText: string
}): React.ReactElement {
  const [showTooltip, setShowTooltip] = useState(false)

  return (
    <div className="flex items-center">
      <span className="text-menu">{title}</span>
      <div
        className="relative ml-2"
        onClick={() => setShowTooltip(!showTooltip)}
        onMouseLeave={() => setShowTooltip(false)}
        onMouseOver={() => setShowTooltip(true)}
      >
        <Tooltip arrowPosition="bottom-center" showTooltip={showTooltip}>
          {tooltipText}
        </Tooltip>
        <SVGIcon icon={QuestionCirclePurpleIcon} />
      </div>
      <div className="ml-6">
        <Toggle onChange={setIsCustomizedView} value={isCustomizedView} />
      </div>
    </div>
  )
}
